import { getRuntimeGlobalState } from "./conversationRuntimeService";
import { getCurrentPromptHost } from "./promptStorage";
function getGlobalState() {
    return getRuntimeGlobalState();
}
function resolvePromptHost(host) {
    return host || getCurrentPromptHost();
}
class PromptLibraryService {
    constructor() {
        this.listeners = new Set();
    }
    getPrompts() {
        return getGlobalState().getPromptLibrary();
    }
    getPromptById(id) {
        return getGlobalState().getPromptById(id);
    }
    getPromptCount() {
        return this.getPrompts().length;
    }
    async addPrompt(prompt) {
        const created = await getGlobalState().addPrompt({
            title: prompt.title,
            content: prompt.content,
            host: resolvePromptHost(prompt.host),
        });
        this.notifyListeners();
        return created;
    }
    async updatePrompt(id, updates) {
        await getGlobalState().updatePrompt(id, updates);
        this.notifyListeners();
    }
    async deletePrompt(id) {
        await getGlobalState().deletePrompt(id);
        this.notifyListeners();
    }
    async setPrompts(prompts) {
        await getGlobalState().setPromptLibrary(prompts);
        this.notifyListeners();
    }
    subscribe(listener) {
        this.listeners.add(listener);
        return () => {
            this.listeners.delete(listener);
        };
    }
    notifyListeners() {
        const currentPrompts = this.getPrompts();
        this.listeners.forEach((listener) => {
            try {
                listener(currentPrompts);
            }
            catch (error) {
                console.error("[PromptLibraryService] Listener error:", error);
            }
        });
    }
}
export const promptLibraryService = new PromptLibraryService();
export default promptLibraryService;
